import { useEffect } from 'react';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';

/**
 * maintainScrollPosition will be saved in session storage when window unload
 * (ie when user clicks on a tile to navigate to VDP)
 * If user clicks on back in the browser, shouldMaintainPosition will prevent
 * scrollToTop from invoking and user will remain in the same scroll position
 */

const merchMaintainScrollPosition = 'merchMaintainScrollPosition';

function scrollToTop() {
  requestAnimationFrame(() =>
    window.scrollTo({
      top: document.documentElement.offsetTop,
      behavior: 'smooth'
    })
  );
}

export default function useScrollToTop() {
  const { request } = useGenerateInventoryRequest(0);

  useEffect(() => {
    const saveScrollPosition = () => {
      sessionStorage.setItem(merchMaintainScrollPosition, 'true');
    };

    window.addEventListener('beforeunload', saveScrollPosition);

    return () => {
      window.removeEventListener('beforeunload', saveScrollPosition);
    };
  }, []);

  useEffect(() => {
    const shouldMaintainPosition = sessionStorage.getItem(
      merchMaintainScrollPosition
    );
    if (shouldMaintainPosition) {
      sessionStorage.removeItem(merchMaintainScrollPosition);
    } else {
      scrollToTop();
    }
  }, [request]);
}
